import { FeatureItem } from "./feature-item";
import { HTMLRow } from './htmlRow';
import { MovingSuppliesItem } from "./movingSuppliesItem";
import { HowToCard } from "./howToCard";
import { PictureCardItem } from "./picture-card-item";
import { ViewAllUnits } from "./viewAllUnits";
import { SmallFooterLink } from './smallFooterLinks'
import { MapMarker } from './MapMarker';

export class ComponentSettings {
  svgType: string;
  features: Array<FeatureItem>;
  sliderUrls: Array<string>;
  showSliderArrows: boolean = false;
  sliderAutoPlay: boolean = true;
  sliderLocationImages: boolean = false;
  simpleSliderLocationImages: boolean = false;
  smallFooterLinks: SmallFooterLink[];
  slideshowRow: {
    sliderUrls: Array<string>,
    titleText: '',
    articleText: any,
    showSliderArrows: boolean,
    sliderAutoPlay: boolean
  };
  pictureCard: {
    title: string,
    buttonText: string,
    buttonUrl: string,
    cardItem: Array<PictureCardItem>
  };
  howToRow: {
    title: string,
    blurb: string,
    cards: Array<HowToCard>,
  };
  useVideoInstead: boolean = false;
  hideVideoAndImagesOnMobile: boolean = false;
  leftButtonScrollsToLocations: boolean = false;
  rightButtonScrollsToLocations: boolean = false;
  videoHeaderUrl: string;
  videoHeaderUrlProd: string;
  simpleHeroTabBox: string = 'original';
  subtractFromFullHeight?: number;
  bigOlButtonsTopText = 'Get Your Free Quote';
  bigOlButtonsBottomText = 'Ready to start your next project? Book online today!';

  htmlRow?: string;
  htmlRows?: Array<HTMLRow>;

  movingSupplies: {
    imageUrl: string,
    itemsOffered: Array<MovingSuppliesItem>,
    hide?: boolean
  };

  simpleSliderBanner: {
    title: 'Find your unit now',
    background: '',
    sliderFilter: 'rgba(0, 0, 0, 0.33)',
    color: '#fff',
    padding: '0',
    titleMargin: 'auto auto 0 auto',
    buttonMargin: '15px auto auto auto',
    titleFontSize: '39px',
    subtitle: 'Find your unit now',
    subtitleBackground: '',
    subtitleColor: '#fff',
    subtitlePadding: '0',
    subtitleMargin: '15px auto',
    subtitleFontSize: '28px'
    buttonText?: null,
    setHeightToScreen?: boolean,
    subtractFromFullHeight?: number
  };
  simpleSliderRowStyles: {
    color: 'transparent'
  };

  separatorBar: {
    title: string,
    text: string
  };

  reserveSuccess: {
    success: string,
    line1: string,
    line2: string
  };

  rentReserveUnit: {
    officeHours: string,
    gateHours: string,
    showInsuranceBlurb: boolean,
    insuranceBlurb: string
  };

  rentSuccess: {
    success: string,
    line1: string,
    line2: string,
    line1Bold: boolean,
    line2Bold: boolean
  };
  smallPrimaryIconBar: {
    title: string,
    title1: string,
    title2: string,
    title3: string,
    icon1url: string,
    icon2url: string,
    icon3url: string,
    card1url: string;
    card2url: string;
    card3url: string;
    text1: string,
    text2: string,
    text3: string,
    backText1: string,
    backText2: string,
    backText3: string,
    alt1: string,
    alt2: string,
    alt3: string,
    seoTitle1: string,
    seoTitle2: string,
    seoTitle3: string,
  };

  maps: {
    markers: Array<MapMarker>,
    latitude: number,
    longitude: number,
    zoom: number,
    styles?: any,
    placement: string,
    blurb: string
  };

  viewAllUnits: ViewAllUnits = new ViewAllUnits();

  facilityInfoBanner: {
    title?: string,
    leftBottomTitle?: string,
    rightTopTitle?: string,
    body?: string,
    imageUrl?: string,
    ctaText?: string,
    ctaLink?: string
  }

  footer?: {
    blurbTitle?: string,
    blurb?: string
  };

  locationsNearYou?: {
    blurbTitle?: string,
    blurb?: string
  };

  homePageBlogBanner?: {
    title?: string,
    blurb?: string,
    useMetaForSummary?: boolean
  };


  homepageLinksCardLinks: {
    iconClass?: string,
    title?: string,
    subtitle?: string,
    link?: string,
    isExternal?: boolean,
  }[];

  constructor(name: string) {
    this.features = [
      { name: 'Facility Feature', iconUrl: 'https://firebasestorage.googleapis.com/v0/b/storpug-main.appspot.com/o/Icon-Placeholder.png?alt=media&token=22d9dd0f-4125-4e66-949a-e2cc0d040be5', title: 'Storage Facility Features', alt: 'Storage Facility Features', description: '' },
      { name: 'Facility Feature', iconUrl: 'https://firebasestorage.googleapis.com/v0/b/storpug-main.appspot.com/o/Icon-Placeholder.png?alt=media&token=22d9dd0f-4125-4e66-949a-e2cc0d040be5', title: 'Storage Facility Features', alt: 'Storage Facility Features', description: '' },
      { name: 'Facility Feature', iconUrl: 'https://firebasestorage.googleapis.com/v0/b/storpug-main.appspot.com/o/Icon-Placeholder.png?alt=media&token=22d9dd0f-4125-4e66-949a-e2cc0d040be5', title: 'Storage Facility Features', alt: 'Storage Facility Features', description: '' },
      { name: 'Facility Feature', iconUrl: 'https://firebasestorage.googleapis.com/v0/b/storpug-main.appspot.com/o/Icon-Placeholder.png?alt=media&token=22d9dd0f-4125-4e66-949a-e2cc0d040be5', title: 'Storage Facility Features', alt: 'Storage Facility Features', description: '' },
      { name: 'Facility Feature', iconUrl: 'https://firebasestorage.googleapis.com/v0/b/storpug-main.appspot.com/o/Icon-Placeholder.png?alt=media&token=22d9dd0f-4125-4e66-949a-e2cc0d040be5', title: 'Storage Facility Features', alt: 'Storage Facility Features', description: '' },
      { name: 'Facility Feature', iconUrl: 'https://firebasestorage.googleapis.com/v0/b/storpug-main.appspot.com/o/Icon-Placeholder.png?alt=media&token=22d9dd0f-4125-4e66-949a-e2cc0d040be5', title: 'Storage Facility Features', alt: 'Storage Facility Features', description: '' },
    ];

    this.videoHeaderUrl = '';
    this.videoHeaderUrlProd = '';
    this.sliderUrls = [
      'https://firebasestorage.googleapis.com/v0/b/storpug-604b6.appspot.com/o/storage_unit.jpg?alt=media&token=3a2b25ad-0379-4443-9ca4-688506a7bccd',
      'https://firebasestorage.googleapis.com/v0/b/storpug-604b6.appspot.com/o/storage_unit.jpg?alt=media&token=3a2b25ad-0379-4443-9ca4-688506a7bccd',
      'https://firebasestorage.googleapis.com/v0/b/storpug-604b6.appspot.com/o/storage_unit.jpg?alt=media&token=3a2b25ad-0379-4443-9ca4-688506a7bccd',
    ];
    this.showSliderArrows = false;
    this.sliderAutoPlay = true;
    this.sliderLocationImages = false;
    this.simpleSliderLocationImages = false;
    this.smallFooterLinks = [];
    this.slideshowRow = {
      sliderUrls: [
        'https://firebasestorage.googleapis.com/v0/b/storpug-604b6.appspot.com/o/storage_unit.jpg?alt=media&token=3a2b25ad-0379-4443-9ca4-688506a7bccd',
        'https://firebasestorage.googleapis.com/v0/b/storpug-604b6.appspot.com/o/storage_unit.jpg?alt=media&token=3a2b25ad-0379-4443-9ca4-688506a7bccd',
        'https://firebasestorage.googleapis.com/v0/b/storpug-604b6.appspot.com/o/storage_unit.jpg?alt=media&token=3a2b25ad-0379-4443-9ca4-688506a7bccd',
      ],
      titleText: '',
      articleText: 'HTML here',
      showSliderArrows: false,
      sliderAutoPlay: true
    };

    this.pictureCard = {
      title: 'What storage do you need?',
      buttonText: 'See All Storage Types',
      buttonUrl: '/units',
      cardItem: [
        new PictureCardItem('Self Storage', 'https://cdn.storagepug.com/hubfs/Client%20Website%20Images/Stock%20Photos/31010069_l.jpg'),
        new PictureCardItem('Student Storage', 'https://cdn.storagepug.com/hubfs/Client%20Website%20Images/Stock%20Photos/31010069_l.jpg'),
        new PictureCardItem('Wine Storage', 'https://cdn.storagepug.com/hubfs/Client%20Website%20Images/Stock%20Photos/31010069_l.jpg'),
        new PictureCardItem('Vehicle Storage', 'https://cdn.storagepug.com/hubfs/Client%20Website%20Images/Stock%20Photos/31010069_l.jpg'),
      ]
    };

    this.howToRow = {
      title: 'Just a simple how to title',
      blurb: 'A paragraph of some text...',
      cards: [
        new HowToCard('title', 'body', '', ''),
        new HowToCard('title 2', 'body 2', '', '')
      ]
    };

    this.movingSupplies = {
      hide: true,
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/storpug-604b6.appspot.com/o/work_man_two.png?alt=media&token=55b07cf7-9afd-4b07-a82f-3f9872becc89',
      itemsOffered: [
        new MovingSuppliesItem('Packaging Tape'),
        new MovingSuppliesItem('Boxes'),
        new MovingSuppliesItem('Stretch Film'),
        new MovingSuppliesItem('Bubble Wrap'),
        new MovingSuppliesItem('Mattress Bags'),
        new MovingSuppliesItem('Moving Blanket'),
        new MovingSuppliesItem('Lights'),
        new MovingSuppliesItem('Rope')
      ]
    };
    this.rentReserveUnit = {
      officeHours: 'Mon-Fri: 10:00A-6:00P / Sat: 9:00A-4:00P',
      gateHours: '6:00A-10P Daily',
      showInsuranceBlurb: false,
      insuranceBlurb: null
    };

    this.reserveSuccess = {
      success: 'Unit successfully reserved!',
      line1: `Thank you for choosing ${ name } for your storage needs! To complete the reservation please come into the office within 7 days of your reservation date.`,
      line2: 'If you have any questions, concerns, or need to make any changes, please don’t hesitate to contact us. We look forward to working with you!'
    };
    this.rentSuccess = {
      success: 'Unit successfully rented!',
      line1: `Thank you for choosing ${ name } for your storage needs! Please stop by the office during business hours to meet with one of our friendly on-site managers. They will confirm all of your details and show you around the facility. If you have any questions, concerns, or need to make any changes, please don’t hesitate to contact us.`,
      line2: 'You can easily see the status of your unit(s), make payments, and manage your account on our website with the account you created during the rental process.',
      line1Bold: false,
      line2Bold: false
    };
    this.smallPrimaryIconBar = {
      title: 'Our Benefits',
      title1: 'Facility Feature',
      title2: 'Facility Feature',
      title3: 'Facility Feature',
      icon1url: 'https://firebasestorage.googleapis.com/v0/b/storpug-main.appspot.com/o/Icon-Placeholder.png?alt=media&token=22d9dd0f-4125-4e66-949a-e2cc0d040be5',
      icon2url: 'https://firebasestorage.googleapis.com/v0/b/storpug-main.appspot.com/o/Icon-Placeholder.png?alt=media&token=22d9dd0f-4125-4e66-949a-e2cc0d040be5',
      icon3url: 'https://firebasestorage.googleapis.com/v0/b/storpug-main.appspot.com/o/Icon-Placeholder.png?alt=media&token=22d9dd0f-4125-4e66-949a-e2cc0d040be5',
      card1url: 'units',
      card2url: 'units',
      card3url: 'units',
      text1: 'Facility Feature placeholder text is here',
      text2: 'Facility Feature placeholder text is here',
      text3: 'Facility Feature placeholder text is here',
      backText1: '',
      backText2: '',
      backText3: '',
      alt1: 'Facility Feature',
      alt2: 'Facility Feature',
      alt3: 'Facility Feature',
      seoTitle1: 'Facility Feature',
      seoTitle2: 'Facility Feature',
      seoTitle3: 'Facility Feature'
    };

    this.maps = {
      placement: 'top',
      blurb: '',
      markers: [],
      latitude: 35.9016015,
      longitude: -84.0210016,
      zoom: 16,
      // iconUrl: 'https://firebasestorage.googleapis.com/v0/b/storpug-604b6.appspot.com/o/map-icon.png?alt=media&token=9e773f5c-393d-4635-9ff6-2806b18d262f',
      // useCustomInfoWindow: true,
      // infoWindowMaxWidth: 400,
      styles: []
    }

    this.svgType = 'svgIconOptions';

    this.footer = {
      blurbTitle: null,
      blurb: null
    }

    this.locationsNearYou = {
      blurbTitle: null,
      blurb: null
    }

    this.separatorBar = {
      title: '',
      text: ''
    }

    this.homePageBlogBanner = {
      title: null,
      blurb: null,
      useMetaForSummary: false
    }

    this.facilityInfoBanner = {
      title: null,
      leftBottomTitle: null,
      rightTopTitle: null,
      body: null,
      imageUrl: null
    }

    this.homepageLinksCardLinks = [
      {
        iconClass: 'attach_money',
        isExternal: false,
        title: 'Rent Now',
        subtitle: 'Rent your self storage unit right on our website 24/7',
        link: '/units'
      },
      {
        iconClass: 'weekend',
        isExternal: false,
        title: 'Size Guide',
        subtitle: 'Need help choosing the right storage unit? Look at our size guide for a reference of what fits',
        link: '/size-guide'
      },
      {
        iconClass: 'account_circle',
        isExternal: false,
        title: 'My Account',
        subtitle: 'Access your online account to conveniently pay, setup autopay, schedule a move out, and more',
        link: '/customer-portal/login'
      },
      {
        iconClass: 'help',
        isExternal: false,
        title: 'Frequently Asked Questions',
        subtitle: 'During our years of storage experience, we have heard it all. Click here for a collection of common questions',
        link: '/faq'
      },
      {
        iconClass: 'insert_emoticon',
        isExternal: false,
        title: 'About Us',
        subtitle: 'Click here to read more about our self storage story',
        link: '/about'
      },
      {
        iconClass: 'phone_in_talk',
        isExternal: false,
        title: 'Contact Us',
        subtitle: 'Questions, comments, or concerns? We always appreciate your feedback',
        link: '/contact'
      }
    ];
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/componentSettings.ts